import { Button } from 'reactstrap';
import { IntlType } from '../../../../utils/typing';

interface Props {
  intl: IntlType;
  handleClick: () => void;
  disabled: boolean;
}

const EditUserButton = (props: Props): JSX.Element => {
  const { intl, handleClick, disabled } = props;

  return (
    <Button
      className="submit-button confirm"
      color="primary"
      onClick={handleClick}
      disabled={disabled}
      data-testid="edit-user-button"
    >
      {intl.formatMessage({ id: 'save' })}
    </Button>
  );
};

export default EditUserButton;
